import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[580px] md:h-[680px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Warm%20artistic%20modern%20education%20abstract%20background%20with%20soft%20golden%20amber%20and%20cream%20gradient%20tones%2C%20elegant%20flowing%20curves%20suggesting%20learning%20and%20growth%2C%20minimalist%20design%20with%20subtle%20texture%2C%20no%20text%20no%20people%2C%20warm%20atmospheric%20light%2C%20high%20quality%20digital%20art&width=1800&height=900&seq=hero-bg-edu-01&orientation=landscape"
        alt="学历提升"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/30 to-black/50"></div>

      <div className="relative z-10 w-full px-4 md:px-6 text-center">
        <div className="max-w-4xl mx-auto">
          <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl text-white mb-6 leading-tight">
            在职进修，轻松<span className="text-primary-400">提升学历</span>
          </h1>
          <p className="text-base md:text-lg text-white/85 max-w-2xl mx-auto mb-10 leading-relaxed">
            专为在职人士打造的高清视频课程平台，涵盖成人高考、自学考试、网络教育、国家开放大学等
            多种学历提升方案，名师辅导，灵活学习，助您轻松获得国家认可学历。
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/category/chengrengaokao"
              className="w-full sm:w-auto px-8 py-3.5 bg-primary-500 text-background-50 rounded-lg text-base font-medium hover:bg-primary-600 transition-all cursor-pointer whitespace-nowrap"
            >
              了解学历提升方案
            </Link>
            <Link
              to="/about"
              className="w-full sm:w-auto px-8 py-3.5 bg-white/15 backdrop-blur-sm text-white border border-white/25 rounded-lg text-base font-medium hover:bg-white/25 transition-all cursor-pointer whitespace-nowrap"
            >
              免费咨询
            </Link>
          </div>
          <div className="flex items-center justify-center gap-8 mt-12 text-white/70 text-sm flex-wrap">
            <div className="flex items-center gap-2">
              <i className="ri-checkbox-circle-fill text-primary-400 text-lg"></i>
              <span>国家承认学历</span>
            </div>
            <div className="flex items-center gap-2">
              <i className="ri-checkbox-circle-fill text-primary-400 text-lg"></i>
              <span>学信网可查</span>
            </div>
            <div className="flex items-center gap-2">
              <i className="ri-checkbox-circle-fill text-primary-400 text-lg"></i>
              <span>名师高清课程</span>
            </div>
            <div className="flex items-center gap-2">
              <i className="ri-checkbox-circle-fill text-primary-400 text-lg"></i>
              <span>灵活学习方案</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}